import { Injectable, inject } from '@angular/core';
import { TranslationPlatform } from '@models/system';
import { TranslateLoader } from '@ngx-translate/core';
import { map, Observable } from 'rxjs';
import { TranslationBundlesService } from './translation-bundles.service';

/** Custom ngx-translate loader that fetches translations from the backend API. */
@Injectable()
export class TranslationApiLoader implements TranslateLoader {
  private readonly translationBundlesService = inject(TranslationBundlesService);

  getTranslation(lang: string): Observable<Record<string, string>> {
    return this.translationBundlesService
      .getBundles(lang, [TranslationPlatform.Angular, TranslationPlatform.Errors])
      .pipe(
        map(bundles => {
          const angular = bundles.Angular ?? {};
          const errors = bundles.Errors ?? {};
          return {
            ...angular,
            ...Object.fromEntries(Object.entries(errors).map(([key, value]) => [`errorCode.${key}`, value])),
          };
        }),
      );
  }
}
